import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";

function App() {
  return (
    <div className="App">
      <Landing />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
